var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('background-image-rotator',{attrs:{"classList":['image-container'],"media":_vm.media,"timing":15000}})}
var staticRenderFns = []

export { render, staticRenderFns }